import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { monitoringService } from '@egw/monitoring'
import { App } from './middleware/app'
import { Mock } from './middleware/mock'
import { config } from './config'

// eslint-disable-next-line no-console -- output app version for debugging purposes
console.info(`Version: v${config.appVersion}`)

// Monitoring Service (Sentry) has to be initialized before the mounting React component
if (config.sentry) {
  monitoringService.init(config)
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(<>{import.meta.env.VITE_MOCK === 'true' ? <Mock /> : <App />}</>)
